import Vue from "vue";
import VueRouter from "vue-router";

import Information from "../views/Information.vue";

import OEE from "../views/OEE.vue";
import OEE2 from "../views/OEE2.vue";
import OEE4 from "../views/OEE4.vue";
import OEE8 from "../views/OEE8.vue";
import OEE12 from "../views/OEE12.vue";

import Disponibilidade from "../views/Disponibilidade.vue";
import Disponibilidade2 from "../views/Disponibilidade2.vue";
import Disponibilidade4 from "../views/Disponibilidade4.vue";
import Disponibilidade8 from "../views/Disponibilidade8.vue";
import Disponibilidade12 from "../views/Disponibilidade12.vue";

import Qualidade from "../views/Qualidade.vue";
import Qualidade2 from "../views/Qualidade2.vue";
import Qualidade4 from "../views/Qualidade4.vue";
import Qualidade8 from "../views/Qualidade8.vue";
import Qualidade12 from "../views/Qualidade12.vue";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "um", component: OEE },
  {
    path: "/oee/1",
    name: "oeeum",
    component: OEE
  },
  {
    path: "/oee/2",
    name: "oeedois",
    component: OEE2
  },
  {
    path: "/oee/4",
    name: "oeequatro",
    component: OEE4
  },
  {
    path: "/oee/8",
    name: "oeeoito",
    component: OEE8
  },
  {
    path: "/oee/12",
    name: "oeedoze",
    component: OEE12
  },
  {
    path: "/oee/info",
    name: "oeeinfo",
    component: Information
  },
  {
    path: "/disponibilidade/1",
    name: "disponibilidadeum",
    component: Disponibilidade
  },
  {
    path: "/disponibilidade/2",
    name: "disponibilidadedois",
    component: Disponibilidade2
  },
  {
    path: "/disponibilidade/4",
    name: "disponibilidadequatro",
    component: Disponibilidade4
  },
  {
    path: "/disponibilidade/8",
    name: "disponibilidadeoito",
    component: Disponibilidade8
  },
  {
    path: "/disponibilidade/12",
    name: "disponibilidadedoze",
    component: Disponibilidade12
  },
  {
    path: "/disponibilidade/info",
    name: "disponibilidadeinfo",
    component: Information
  },
  {
    path: "/qualidade/1",
    name: "qualidadeum",
    component: Qualidade
  },
  {
    path: "/qualidade/2",
    name: "qualidadedois",
    component: Qualidade2
  },
  {
    path: "/qualidade/4",
    name: "qualidadequatro",
    component: Qualidade4
  },
  {
    path: "/qualidade/8",
    name: "qualidadeoito",
    component: Qualidade8
  },
  {
    path: "/qualidade/12",
    name: "qualidadedoze",
    component: Qualidade12
  },
  {
    path: "/qualidade/info",
    name: "qualidadeinfo",
    component: Information
  }
];

const router = new VueRouter({
  // mode: "history",
  // base:
  //   process.env.NODE_ENV === "production"
  //     ? "/Viewer/Home/Index"
  //     : process.env.BASE_URL,
  routes
});

export default router;
